<wa-dialog class="changelog-dialog" label="What's new" [lightDismiss]="true" [open]="isOpen()" (wa-hide)="onHide($event)">
    <div class="changelog-feed" data-testid="changelog-dialog">
        @for (entry of entries(); track entry.id) {
            <article class="changelog-entry" data-testid="changelog-entry">
                <div class="changelog-header">
                    <wa-icon class="changelog-icon" name="sparkles" variant="regular" />
                    <div class="changelog-heading">
                        <div class="changelog-title-row">
                            <h5>{{ entry.title }}</h5>
                            @if (entry.is_new) {
                                <wa-badge appearance="filled" data-testid="changelog-new-badge" variant="brand">NEW</wa-badge>
                            }
                        </div>
                        <span class="changelog-date">{{ entry.published_date }}</span>
                    </div>
                </div>

                <div class="changelog-body" [innerHTML]="entry.body_html"></div>

                @if (entry.screenshots.length > 0) {
                    <wa-carousel class="changelog-screenshots" navigation pagination>
                        @for (shot of entry.screenshots; track shot.url) {
                            <wa-carousel-item>
                                <button
                                    class="screenshot-expand"
                                    data-testid="changelog-screenshot"
                                    type="button"
                                    (click)="openLightbox(shot)">
                                    <img loading="lazy" [alt]="shot.caption || 'Changelog screenshot'" [src]="shot.url" />
                                </button>
                            </wa-carousel-item>
                        }
                    </wa-carousel>
                }
            </article>
        } @empty {
            <!-- The feed can legitimately be empty: entries are published per
                 environment from the admin console (ADR-0019), and audience-gated
                 entries don't reach users outside the internal org. Say so, rather
                 than rendering an empty dialog body. A failed load gets different
                 copy - telling someone they're caught up when the request errored
                 would be wrong. -->
            @if (loadFailed()) {
                <div class="changelog-placeholder" data-testid="changelog-load-error">
                    <wa-icon class="changelog-icon" name="triangle-exclamation" variant="regular" />
                    <p>We couldn't load the latest updates. Please try again in a moment.</p>
                </div>
            } @else {
                <div class="changelog-placeholder" data-testid="changelog-empty">
                    <wa-icon class="changelog-icon" name="sparkles" variant="regular" />
                    <p>You're all caught up. New updates will show up here.</p>
                </div>
            }
        }
    </div>

    <wa-button class="changelog-dismiss" size="m" slot="footer" variant="brand" (click)="onDismiss()">Got it</wa-button>
</wa-dialog>

<!-- Sibling of the feed dialog (not nested) so its wa-hide can't bubble into
     onHide and ack the feed; the native top layer stacks it above regardless. -->
<app-image-lightbox [image]="lightboxImage()" (closed)="closeLightbox()" />
